interface LoadingPayload {
  title?: string;
  description?: string;
}

type LoadingState = LoadingPayload & { visible: boolean };

type Listener = (state: LoadingState) => void;

let state: LoadingState = { visible: false };
const listeners = new Set<Listener>();

const notify = () => {
  listeners.forEach((l) => l(state));
};

export const loadingService = {
  show(payload: LoadingPayload = {}) {
    state = { ...payload, visible: true };
    notify();
  },
  hide() {
    state = { visible: false };
    notify();
  },
  subscribe(listener: Listener) {
    listeners.add(listener);
    listener(state);
    return () => listeners.delete(listener);
  },
};
